import {Team, TeamCategory} from "@irati/types"

export default function getTeamCategory(team: Team): string {
  if (team.teamCategory && team.teamCategory !== TeamCategory.Unknown) {
    return team.teamCategory
  }
  return TeamCategory.Department
}
